// import BulmaRadio from './BulmaRadio'
// import BulmaRadioGroup from './BulmaRadioGroup'
// import BulmaRadioButton from './BulmaRadioButton'

const BulmaRadio = r => require.ensure([], () => r(require('./BulmaRadio.vue')), 'shared')
const BulmaRadioButton = r => require.ensure([], () => r(require('./BulmaRadioButton.vue')), 'shared')

export { BulmaRadio, BulmaRadioButton }
